// App Urls
const baseUrl = '';

export const homeUrl = `${baseUrl}/`;
export const loginUrl = `${baseUrl}/login`;
export const logoutUrl = `${baseUrl}/logout`;
export const signUpUrl = `${baseUrl}/sign-up`;

export const myProfileUrl = `${baseUrl}/my-profile`;
export const videoChatUrl = `${baseUrl}/video-chat`;